import Options from "components/inputs/Options"
import { css } from "@emotion/css"

import { useCallback, useState } from "react"

const styles = {
  root: css`
    height: 51px;
  `,
  label: css`
    font-size: 13px;
    color: var(--neutral-400, #a8a8a8);
  `,
  paper: css`
    min-width: 160px !important;
    li {
      font-size: 14px;
      :hover {
        background-color: var(--primary-light) !important;
      }
    }
  `,
}

export default function SegmentSelect({
  onChangeSegment,
  defaultSegment,
  segmentOptions,
}: {
  onChangeSegment: (value: string) => void
  defaultSegment: string
  segmentOptions: { value: string; label: string }[]
}) {
  const [segment, setSegment] = useState(defaultSegment)

  const onSegmentChange = useCallback(
    (e) => {
      setSegment(e.target.value)
      onChangeSegment(e.target.value)
    },
    [onChangeSegment],
  )

  return (
    <Options
      name="rates"
      label="Running Rates"
      value={segment}
      options={segmentOptions}
      inputLabelClass={styles.label}
      rootClass={styles.root}
      onChange={onSegmentChange}
      paperClass={styles.paper}
    />
  )
}
